import { LOOKUP_INFO_IMAGE_MODAL_NAMESPACE } from "constants/i18n-namespaces";
import React from "react";
import { useTranslation } from "react-i18next";

export interface ILookupInfoImageModalProps {
  payableTypeName: string;
  whereIsLookupInfoImg: string;
}

export const LookupInfoImageModal = (props: ILookupInfoImageModalProps) => {
  const { payableTypeName, whereIsLookupInfoImg } = props;
  const { t } = useTranslation(LOOKUP_INFO_IMAGE_MODAL_NAMESPACE);
  return (
    <div className="bill-modal-window">
      <div className="modal-label-bill">
        {t("lookup-info-image-modal-label", { lookupName: payableTypeName })}
      </div>
      <img
        src={whereIsLookupInfoImg}
        alt={t("lookup-info-image-alt-text")}
        className="bill-image"
      ></img>
    </div>
  );
};
